import { forwardRef } from 'react';
import { CardLayout } from '../../lib/card';
import { usePost } from '../Post';
import {
  CardActionsBlock,
  CardContainer,
  CardMediaBlock,
  CardPreviewLinkBlock,
  CardRepostPreviewBlock,
  CardTextBlock,
  CardUserBlock
} from '../parts';
import { usePostAction, usePostSettings } from '../utils';

interface Card1Props {
  space: number;
}

export const Card1 = forwardRef<HTMLDivElement, Card1Props>(
  ({ space, ...forwardingProps }, forwardingRef) => {
    const { hasMedia, horizontal, hasRepost, showMedia, showTextLink } =
      usePost();
    const { backgroundColor, borderRadius, showShadow, shadow } =
      usePostSettings();
    const handleAction = usePostAction();

    return (
      <CardContainer
        {...forwardingProps}
        ref={forwardingRef}
        onClick={handleAction}
        _space={space}
        _backgroundColor={backgroundColor}
        _borderRadius={borderRadius}
        _shadow={showShadow ? shadow : undefined}
      >
        {horizontal ? (
          <CardLayout.Columns>
            <CardLayout.HorizontalCardContentContainer>
              <CardUserBlock withSource />
              <CardTextBlock grow />
              <CardRepostPreviewBlock ratio={0.66} />
              {showTextLink && <CardPreviewLinkBlock />}
              <CardActionsBlock withTopDivider />
            </CardLayout.HorizontalCardContentContainer>

            {showMedia && <CardMediaBlock thumbnail ratio={0.66} />}
          </CardLayout.Columns>
        ) : (
          <>
            <CardUserBlock withSource />
            <CardTextBlock />
            <CardRepostPreviewBlock ratio={0.66} />
            {showTextLink && <CardPreviewLinkBlock />}
            {showMedia && <CardMediaBlock thumbnail ratio={0.66} />}
            <CardActionsBlock withTopDivider={!hasMedia && !hasRepost} />
          </>
        )}
      </CardContainer>
    );
  }
);

Card1.displayName = 'Card1';
